import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import "./JournalDetails.css";

export default function JournalDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [journal, setJournal] = useState(null);
  const [loading, setLoading] = useState(true);

  // Get backend URL from env var and strip trailing slash if any
  const backendBaseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

  useEffect(() => {
    async function fetchJournal() {
      try {
        const resp = await api.get(`journals/${id}`);
        setJournal(resp.data);
      } catch (err) {
        alert("Failed to load journal: " + (err.response?.data?.msg || err.message));
        navigate("/");
      } finally {
        setLoading(false);
      }
    }
    fetchJournal();
  }, [id, navigate]);

  if (loading) return <div>Loading journal details...</div>;
  if (!journal) return null;

  return (
    <div className="journal-details">
      <button onClick={() => navigate(-1)} style={{ marginBottom: 20 }}>← Back</button>
      <h1>{journal.title}</h1>
      <p><em>Location: {journal.location}</em></p>
      {journal.map && (
        <p>
          <a href={journal.map} target="_blank" rel="noopener noreferrer">View Map</a>
        </p>
      )}
      <div className="journal-photos">
        {journal.photos && journal.photos.map((url, idx) => (
          <img
            key={idx}
            src={url.startsWith("http") ? url : `${backendBaseUrl}${url}`}
            alt={`${journal.title} - ${idx + 1}`}
          />
        ))}
      </div>
      <p>{journal.description}</p>
      <div>
        <h3>Itinerary</h3>
        <ul>
          {journal.itinerary.map((day, i) => (
            <li key={i}>
              <strong>Day {day.day}:</strong> {day.activities}
            </li>
          ))}
        </ul>
      </div>
      
    </div>
  );
}
